
import { Component, Vue, Prop } from 'vue-property-decorator';

type AlertType = 'info' | 'success' | 'warning' | 'error';

@Component
export default class InfoAlert extends Vue {
  @Prop({ required: true }) readonly message!: string;
  @Prop({ default: 'info' }) readonly type!: AlertType;
  @Prop({ default: false }) readonly dismissible!: boolean;

  get alertClasses(): string {
    const typeClasses = {
      info: 'bg-blue-50 border-blue-400',
      success: 'bg-green-50 border-green-400',
      warning: 'bg-amber-50 border-amber-400',
      error: 'bg-red-50 border-red-400',
    };

    return typeClasses[this.type] || typeClasses.info;
  }

  get iconClass(): string {
    const iconClasses = {
      info: 'fas fa-info-circle text-blue-600',
      success: 'fas fa-check-circle text-green-600',
      warning: 'fas fa-exclamation-triangle text-amber-600',
      error: 'fas fa-exclamation-circle text-red-600',
    };

    return iconClasses[this.type] || iconClasses.info;
  }

  get textClass(): string {
    const textClasses = {
      info: 'text-blue-700',
      success: 'text-green-700',
      warning: 'text-amber-700',
      error: 'text-red-700',
    };

    return textClasses[this.type] || textClasses.info;
  }
}
